import RootReducer, { ReducerKeys } from './reducers';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore } from 'redux-persist';

// Middleware: Redux Persist Persisted Reducer
const middlewares = [applyMiddleware(thunk)];
const store = createStore(RootReducer, compose(...middlewares));

export const getState = (reducerKey: ReducerKeys): any => {
  if (reducerKey in store.getState()) return store.getState()[reducerKey];
  return store.getState();
};

export const persistor = persistStore(store);
export default store;
